import Vue from 'vue'
import Vuex from 'vuex'

import proveniences from './proveniences'
import banks from './banks'
import insurances from './insurances'
import users from './users'

Vue.use(Vuex)

/*
 * If not building with SSR mode, you can
 * directly export the Store instantiation
 */

export default function (/* { ssrContext } */) {
  const Store = new Vuex.Store({
    modules: {
      proveniences,
      banks,
      insurances,
      users
    },

    state: {
      dev: process.env.NODE_ENV === 'development'
    },

    getters: {
      isValidDate: () => date => date && !['0000-00-00', '1970-01-01', '1970-01-01 00:00:00'].includes(date),
      isValidSignaller: () => sId => sId && sId !== 316,
      currency: () => a => (a / 1).toFixed(2).replace('.', ',').toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    },

    mutations: {
      SET_DEV (state, val) { state.dev = val }
    }

    // enable strict mode (adds overhead!)
    // for dev mode only
    // strict: process.env.DEV
  })

  return Store
}
